export const INTRO_CONSTANTS = {
  text: "Rising infrastructure costs. Vendor lock-in. Performance bottlenecks. With Zadara’s fully-managed edge cloud solutions , you gain elastic , consumption-based storage and compute—delivered wherever you need it. Enjoy the freedom of enterprise-grade performance, zero CapEx, and seamless migration paths—backed by 24/7 expert support. ",
};
